export default "__VITE_ASSET__C7qaA9Lh__"